import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject, filter, takeUntil } from 'rxjs';
import { ConfirmDialogComponent } from 'src/app/components/dialogs/confirm-dialog/confirm-dialog.component';
import { OpenCaseTemplateComponent } from 'src/app/components/dialogs/open-case-template/open-case-template.component';
import { RefundAmountComponent } from 'src/app/components/dialogs/refund-amount/refund-amount.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { updateShipmentDiscrepancy } from 'src/app/models/shipmentMonitor.model';
import { ShipmentMonitorService } from 'src/app/services/shipment-monitor.service';

@Component({
  selector: 'app-case-status-cell-renderer',
  templateUrl: './case-status-cell-renderer.component.html',
  styleUrls: ['./case-status-cell-renderer.component.scss']
})
export class CaseStatusCellRendererComponent implements OnInit,OnDestroy{
  params:any;
  claimStatus:any;
  selectedStatus;
  status:any;
  private destroy$ = new Subject<void>();
  constructor(private dialog:MatDialog,
    private shipmentMonitorService:ShipmentMonitorService,
    private snackbar:MatSnackBar){}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  ngOnInit(): void {
  }
  agInit(params:any){
   this.params = params;
   this.claimStatus = this.params.status;
   let index =  this.claimStatus.findIndex((el) => el.caseStatusId == this.params?.data?.CaseStatusId);
    if(index !== -1){
      this.selectedStatus = this.claimStatus[index];
    }
  }

  openCaseDialog(evt,params){
    evt.preventDefault();
    evt.stopPropagation();
    this.dialog.open(OpenCaseTemplateComponent, {
      width: "601px",
      data: {
        title:'Open Case',
        actions: [
          { text: "Cancel"},
          { text: "Copy Text & Open Case"},
        ],
        shipmentDiscrepancyId:params.data.ShipmentDiscrepancyId,
        isCellAction:true
      },
    }).afterClosed().subscribe((res)=>{
      if(res){
        if(res){
          this.params.api.refreshServerSide({});
        }
      }
    });
  }

  openDialog(isLink?){   
    this.dialog.open(RefundAmountComponent, {
      width: "472px",
      data: {
        title:isLink ? 'Add Link': 'Refund Amount',
        isLink:isLink
      },
    }).afterClosed().subscribe((res)=>{
      if(res){
        if(res.link){
          this.params.data.CaseLink = res.link;
        } 
        if(res.refundedAmount) {
          this.params.data.RefundedAmount = res.refundedAmount;
        }
        this.updateStatus();
      }
    })
  }

  updateStatus(isDelete?,isMsg?){
    const paylaod:updateShipmentDiscrepancy = {
    shipmentDiscrepancyId: this.params.data.ShipmentDiscrepancyId,
    isCaseCreated: this.params.data.isCaseCreated,
    caseStatusId: this.params.data.CaseStatusId,
    caseLink: isDelete ? null : this.params.data.CaseLink ,
    note: this.params.data.Note,
    refundedAmount:this.params.data.RefundedAmount
    }
    this.shipmentMonitorService.updateShipmentDiscrepancy(paylaod).pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
      if(res){
        if(isDelete) this.params.data.CaseLink = null;
        this.params.api.refreshServerSide();
      }
      this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: isMsg ? 'Link has been deleted successfully' : 'Status has been updated successfully',
            action: 'Dismiss',
            type: 'success',
          },
        }
      );
      },
      error: (err) => {
      this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error?.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
      }
    })
  }

  onChange(event){
    this.params.data.CaseStatusId = event.caseStatusId;
      this.updateStatus();
  }

  deleteLink(event){
    event.preventDefault();
    event.stopPropagation();
    this.dialog.open(ConfirmDialogComponent, {
      width: "500px",
      data: {
        title: "Remove Link",
        message: `Are you sure you want to remove this link?`,
        actions: [
          { text: "Cancel", buttonStyle: "underline" },
          { text: "Confirm", buttonColor: "accent", buttonStyle: "wire" },
        ],
      },
    })
      .afterClosed()
      .pipe(filter((e) => e === "Confirm"))
      .subscribe((e) => {
        this.updateStatus(true,true);
      });
  }

  openRefundAmount(isAmount?){
    this.dialog.open(RefundAmountComponent, {
      width: "472px",
      data: {
        title:'Refund Amount',
        amount:isAmount,
        isLink:false
      },
    }).afterClosed().subscribe((res)=>{
       if(res){
        if(res.refundedAmount) {
          this.params.data.RefundedAmount = res.refundedAmount;
        }
        this.updateStatus();
       }
    })
  }

  openLink(link){
    window.open(link, "_blank");
  }
}
